import angular from "angular";

import restangular from "./restangular";
import ConfigService from "./ConfigService";

export default angular.module("services.ServiceRA",[restangular,ConfigService])
.factory("ServiceRA",["Restangular","ConfigService",function DownloadRA(Restangular, ConfigService) {
  return Restangular.withConfig(function (RestangularConfigurer) {
    RestangularConfigurer.setBaseUrl(ConfigService.get("urls.dcb-ea-customer-outside", true) || ConfigService.get("urls.dcb-ea-customer", true));
  });
}]).name;



// WEBPACK FOOTER //
// ./src/ui/app/services/ServiceRA.js